module.exports = {"410105001":"经八路街道","410105002":"花园路街道","410105003":"人民路街道","410105004":"杜岭街道","410105005":"大石桥街道","410105006":"南阳路街道","410105007":"南阳新村街道","410105008":"文化路街道","410105009":"丰产路街道","410105010":"东风路街道","410105011":"北林路街道","410105012":"未来路街道","410105013":"凤凰台街道","410105014":"龙子湖街道","410105015":"祭城路街道","410105016":"兴达路街道","410105017":"国基路街道","410105018":"杨金路街道","410105019":"丰庆路街道","410105560":"如意湖街道","410105561":"博学路街道","410105562":"龙湖街道","410105563":"龙源路街道","410105564":"金光路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410105.json
// module id = 1635
// module chunks = 0